import React from 'react';
import {
  translate as t,
} from 'admin-on-rest';
import { ListItem, Avatar } from 'material-ui';

import { getTranslationByLocale } from '../../../utils/TranslationUtils';

const Image = t(({ block, locale }) => (
  <ListItem disabled className="image" leftAvatar={<Avatar src={block.url} />} primaryText={getTranslationByLocale(block.alt, locale)} />
));

export default Image;
